<template>
  <div id="indexPage" style="height: 100%">
    <input v-model="token" type="text">
    <input v-model="openId" type="text">
  </div>
</template>

<script>
let inter
export default {
  name: 'index',
  data () {
    return {
      token: window.localStorage.getItem('TaToken'),
      openId: window.localStorage.getItem('openId')
    }
  },
  destroyed () {
    clearInterval(inter)
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
.mainPage {
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
  /* background: url("../../../assets/indexBg.png") no-repeat;
  background-size: 100%;
  background-position-x: center; */
  background-color: #f3f4f6;
  height: 100%;
  overflow: scroll;
}
.topSearch {
  height: 60px;
  line-height: 60px;
  width: 96%;
  margin: 0 auto;
}
.main {
  flex: 1;
  width: 100%;
  margin: 0 auto 3% auto;
  overflow: scroll;
}
.mainMenu {
  background-color: #ffffff;
  height: 60px;
  line-height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 1rem;
  border-top: 1px solid #c1c2c4;
  color: #132033;
}
.mainMenu > div {
  flex: 1;
  text-align: center;
}
.mainMenu > div.active {
  color: #0bc98b;
}
.menuActive {
  background-color: #efefef;
}
.mainMenu p:first-child>i {
  font-size: 1.4rem;
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/login/getToken.vue